import { useEffect, useState } from "react";
import { deleteLink, fetchLinksThematicsWithOffsetAndLimit } from "../../HTTP/thematics";
import SearchComponent from "./SearchComponent";
import TableElements from "./TableElements";
import ListElementsMobile from "./ListElementsMobile";
import Pagination from "../../Helper/Pagination";


export const LinksThematicAdmin = () => {
    const localUser = JSON.parse(localStorage.getItem("user"))
    if (!localUser.super_admin && localUser.admin_access !== 6) {
        window.location.href = '/'
    }
    const url = new URL(window.location.href)
    if (url.searchParams.get('page') === null) {
        url.searchParams.set('page', 1);
        window.history.pushState({}, '', url);
    }
    if (url.searchParams.get('country') === null) {
        url.searchParams.set('country', 'ac');
        window.history.pushState({}, '', url);
    }

    const [searchDone, setSearchDone] = useState(false);
    const [launchSearch, setLaunchSearch] = useState(false);
    const [linksThematics, setLinksThematics] = useState({});
    const [searchTerm, setSearchTerm] = useState(url.searchParams.get('query') === null ? '' : url.searchParams.get('query'));
    const [currentPage, setCurrentPage] = useState(parseInt(url.searchParams.get('page')));
    const [linksThematicsPerPage] = useState(100);
    const [nbLinksThematics, setNbLinksThematics] = useState(0);
    const [country, setCountry] = useState(url.searchParams.get('country') === null ? '' : url.searchParams.get('country'));

    useEffect(() => {
        setSearchDone(false)
        
        const getLinksThematics = async () => {
            try {
                const res = await fetchLinksThematicsWithOffsetAndLimit(country, (currentPage - 1) * linksThematicsPerPage, currentPage * linksThematicsPerPage, searchTerm)
                console.log("res", res)
                setLinksThematics(res.data || [])
                setNbLinksThematics(res.count)
                setSearchDone(true)  // Déplacé ici pour s'assurer que les données sont chargées
                setLaunchSearch(false)
            } catch (error) {
                console.error("Erreur lors du chargement des linksThematics:", error)
                setSearchDone(true)  // Important de définir searchDone même en cas d'erreur
                setLaunchSearch(false)
            }
        }
        getLinksThematics()
    }, [country, currentPage, launchSearch, linksThematicsPerPage])

    const paginate = (pageNumber) => {
        url.searchParams.set('page', pageNumber);
        window.history.pushState({}, '', url);
        setCurrentPage(pageNumber)
    }

    const handleQuery = (e) => {
        e.preventDefault();
        url.searchParams.set('page', 1);
        url.searchParams.set('query', searchTerm);
        setCurrentPage(1)
        window.history.pushState({}, '', url);
        setLaunchSearch(true)
    }

    const handleAddCse = () => {
        window.location.href = '/admin/linksthematics/add'
    }

    const handleEditCse = (id) => {
        window.location.href = '/admin/linksthematics/edit/' + id
    }

    const handleDelete = async (id) => {
        if (window.confirm("Êtes-vous sûr de vouloir supprimer ce linksThematics ?")) {
            const res = await deleteLink(id)
            if (res) {
                alert("linksThematics supprimé avec succès")
                setLaunchSearch(true)
            } else {
                alert("Erreur lors de la suppression du linksThematics")
            }
        }
    }

    const handleChangeCountry = (event) => {
        url.searchParams.set('country', event.target.value);
        window.history.pushState({}, '', url);
        setCountry(event.target.value)
        setLaunchSearch(true)
    }

    console.log("linksThematics", linksThematics)
    console.log("nbLinksThematics", nbLinksThematics)

    return (
        <div className="flex flex-row mt-8">
            <div className="flex-grow px-4 sm:px-6 lg:px-8">
                <div className="flex flex-col sm:flex-row items-center justify-normal sm:justify-between mb-6 mt-8 xl:mt-0">
                    <h1 className="text-2xl font-bold text-center flex-grow mt-2">
                        Modération des liens dans les thématiques
                    </h1>
                </div>
                    <SearchComponent
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                    handleQuery={handleQuery}
                    dropdownList={localUser.super_admin === 1 ? {select:'Pays', value:country, handle:handleChangeCountry} : {}}
                    otherButton={{title:'Ajouter', handle:handleAddCse}}
                />
                {linksThematics && linksThematics.length > 0 ? (
                    <>
                <div className='hidden xl:block'>
                    <TableElements 
                        columns={[{props:'label',display:"Nom du site"},
                        {props:'name',display:"Thématique"}, 
                        {props:'country',display:"Pays", format:'country'}, 
                        {props:'',display:"Actions"}
                        ]}
                        data={linksThematics}
                        buttons={[{display:'Éditer',action:handleEditCse, color:'blue', props:'id'}, 
                        {display:'Supprimer',action:handleDelete, color:'red', props:'id'}]}
                    />
                </div>
                <div className="xl:hidden w-full px-4 space-y-4">
                    <ListElementsMobile 
                        columns={[{props:'name',display:"Thématique"}, 
                            {props:'country',display:"Pays", format:'country'}, 
                            {props:'',display:"Actions"}
                        ]}
                        data={linksThematics}
                        buttons={[{display:'Éditer',action:handleEditCse, color:'blue', props:'id'}, 
                        {display:'Supprimer',action:handleDelete, color:'red', props:'id'}]}
                        little={true}
                    />
                </div>
                {searchDone && <Pagination
                    itemsPerPage={linksThematicsPerPage}
                    totalItems={nbLinksThematics}
                    paginate={paginate}
                    currentPage={currentPage}
                />}</>
                    ) : searchDone ? (
                    <p>Aucune donnée disponible</p>
                    ) : (
                    <p>Chargement en cours...</p>
                )}
                    
            </div>
        </div>
    )
}